<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Solicitação de Serviços de Enfermagem"
    >
        <List
            v-if="layout === 'list'"
            :data="data"
            @edit="handleEdit"
        />

        <Form
            v-else
            :data="data"
            :model="model"
            @saved="saved"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <template v-if="layout === 'list'">
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="handleCreate"
                    color="primary"
                >
                    Novo serviço de enfermagem
                </rkm-button>
            </template>

            <template v-else>
                <rkm-button @click="layout = 'list'">
                    Voltar
                </rkm-button>

                <rkm-button
                    @click="handleSave"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

export default {
    components: { Form, List },
    data: () => ({
        layout: null,
        model: null,
    }),
    methods: {
        open() {
            this.layout = 'list'
            this.$refs.RkmModal.show()
        },
        handleCreate() {
            this.model = Object.assign({}, {
                id: null,
                procedimento: null,
                observacoes: null
            })

            this.layout = 'form'
        },
        handleEdit(item) {
            this.model = Object.assign({}, {
                id: item.id,
                procedimento: item.procedimento,
                observacoes: item.observacoes
            })

            this.layout = 'form'
        },
        handleSave() {
            this.$refs.Form.save()
        },
        saved() {
            this.layout = 'list'
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>